var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 502 502",
    style: {
      enableBackground: "new 0 0 502 502"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M492,87.984h-33.036v-3.389c0-2.753-1.135-5.384-3.137-7.272c-2.004-1.891-4.707-2.866-7.442-2.711L251,86.054 L53.615,74.612c-2.75-0.155-5.441,0.82-7.442,2.711c-2.002,1.889-3.137,4.52-3.137,7.272v3.389H10c-5.522,0-10,4.478-10,10 v319.42c0,5.522,4.478,10,10,10h482c5.522,0,10-4.478,10-10V97.984C502,92.462,497.522,87.984,492,87.984z M261,105.509 l177.964-10.316v274.521L261,380.03V105.509z M63.036,95.192L241,105.509V380.03L63.036,369.713V95.192z M482,407.404H20v-299.42 h23.036V379.15c0,5.298,4.132,9.677,9.421,9.983l197.964,11.477c0.193,0.011,0.384,0.016,0.575,0.016c0.001,0,0.002,0,0.003,0 H251h0.001c0.001,0,0.002,0,0.003,0c0.192,0,0.384-0.006,0.575-0.016l197.964-11.477c5.289-0.307,9.421-4.686,9.421-9.983 V107.984H482V407.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M214.281,130.08l-69.813-4.047c-5.516-0.327-10.242,3.892-10.563,9.404c-0.319,5.514,3.892,10.243,9.404,10.563 l69.813,4.047c0.197,0.012,0.394,0.017,0.588,0.017c5.258,0,9.666-4.104,9.975-9.421 C224.005,135.129,219.794,130.399,214.281,130.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M92.623,143.061l17.215,0.998c0.197,0.012,0.394,0.017,0.588,0.017c5.258,0,9.666-4.104,9.975-9.421 c0.319-5.514-3.891-10.243-9.404-10.562l-17.215-0.998c-5.541-0.32-10.242,3.892-10.563,9.404 C82.899,138.012,87.109,142.742,92.623,143.061z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M214.281,175.984l-120.5-6.985c-5.541-0.319-10.242,3.892-10.563,9.404c-0.319,5.514,3.891,10.243,9.404,10.563 l120.5,6.985c0.197,0.012,0.394,0.017,0.588,0.017c5.258,0,9.666-4.104,9.975-9.421 C224.005,181.033,219.795,176.303,214.281,175.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M214.281,222.845l-120.5-6.985c-5.541-0.317-10.242,3.892-10.563,9.404c-0.319,5.514,3.891,10.243,9.404,10.563 l120.5,6.985c0.197,0.012,0.394,0.017,0.588,0.017c5.258,0,9.666-4.104,9.975-9.421 C224.005,227.894,219.795,223.165,214.281,222.845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M214.281,268.751l-120.5-6.985c-5.541-0.317-10.242,3.892-10.563,9.404c-0.319,5.514,3.891,10.243,9.404,10.563 l120.5,6.985c0.197,0.012,0.394,0.017,0.588,0.017c5.258,0,9.666-4.104,9.975-9.421 C224.005,273.8,219.795,269.07,214.281,268.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M410.131,261.765l-74.595,4.324c-5.514,0.319-9.724,5.049-9.404,10.563c0.309,5.316,4.716,9.421,9.975,9.421 c0.194,0,0.391-0.005,0.588-0.017l74.595-4.324c5.514-0.319,9.724-5.049,9.404-10.563 C420.373,265.657,415.685,261.442,410.131,261.765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M305.889,267.808l-16.258,0.942c-5.513,0.319-9.724,5.049-9.404,10.563c0.309,5.316,4.716,9.421,9.975,9.421 c0.194,0,0.391-0.005,0.588-0.017l16.258-0.942c5.513-0.319,9.724-5.049,9.404-10.563 C316.131,271.7,311.417,267.485,305.889,267.808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M410.131,215.86l-120.5,6.985c-5.514,0.319-9.724,5.049-9.404,10.563c0.309,5.316,4.716,9.421,9.975,9.421 c0.194,0,0.391-0.005,0.588-0.017l120.5-6.985c5.514-0.319,9.724-5.049,9.404-10.563 C420.373,219.752,415.685,215.543,410.131,215.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M410.131,168.999l-120.5,6.985c-5.514,0.319-9.724,5.049-9.404,10.563c0.309,5.316,4.716,9.421,9.975,9.421 c0.194,0,0.391-0.005,0.588-0.017l120.5-6.985c5.514-0.319,9.724-5.049,9.404-10.563 C420.373,172.89,415.685,168.671,410.131,168.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M410.131,123.094l-120.5,6.985c-5.514,0.319-9.724,5.049-9.404,10.563c0.309,5.316,4.716,9.421,9.975,9.421 c0.194,0,0.391-0.005,0.588-0.017l120.5-6.985c5.514-0.319,9.724-5.049,9.404-10.563 C420.373,126.986,415.685,122.771,410.131,123.094z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.1b20971e90d3b706ac9eaa63f11b7c01.svg";
export { ForwardRef as ReactComponent };